module.exports = __webpack_public_path__ + "img/IncentableStar.3d8d95dc.png";